export const PRODUCTSLIST_REQUEST = "PRODUCTSLIST_REQUEST";
export const PRODUCTSLIST_SUCCESS = "PRODUCTSLIST_SUCCESS";
export const PRODUCTSLIST_ERROR = "PRODUCTSLIST_ERROR";
export const PRODUCTSLIST_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'AppProductsV1',
    size: 1000,
    filter: []
};
